export default function SelectGroupPrompt() {

  return (
    <div className="flex flex-col pt-2 pb-4">
      <div className="flex justify-center pb-4 pt-2">
        <div className="flex size-10 animate-bounce items-center justify-center rounded-full bg-white p-2 ring-1 ring-green-900/5">
          <svg className="size-6 text-green-500 rotate-180" fill="none" strokeLinecap="round" strokeLinejoin="round"
            strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </div>

      <div className="flex justify-center font-bold text-center px-4">
        <div className='space-y-2 text-slate-700'>
          <p>Olá, como você está participando de mais de um Bolão é preciso selecionar um acima. </p>
          <p>Caso depois queira mudar de Bolão não tem mistério, basta selecionar outro nesta mesma caixa.</p>
        </div>
      </div>
    </div>
  )
}
